'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @returns {Array} - Array of transformed applicants.
 */

function updateData(additionalData, application) {
  if (application.additional_data.school === 'other') {
    additionalData.school = 'other';
  }
  return additionalData;
}

exports.default = function (formValues) {
  return [].concat(_toConsumableArray(formValues.applicant.map(function (applicant, i) {
    return _extends({}, applicant, {
      primary_applicant: i === 0,
      country_code: 'CA',
      additional_data: updateData(applicant.additional_data, formValues.application)
    });
  })));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student-accident/applicant.js
// module id = 1738
// module chunks = 0